// extracted by mini-css-extract-plugin
export default {"bg":"ICGV6F","inlineContent":"OSAD5Q","pageWrapper":"QZVVCT","root":"IFDbAj"};